import { ChangeEvent, useEffect, useRef, useState 	} from "react";
import { titleAddressMBClass, titleAddressMRClass, inputAddressMRClass, inputAddressMBClass } from "src/components/common/common";
import useScreenStore from "src/store/useScreenStore";
import { handleKeyDown } from "src/utils/commonForm/commonFormUtils";

interface Props {
  post: string;
  address: string;
  detailAddress: string;
  editable?: boolean;
  handleFoucsId?: string;
  titleless?: boolean;
  wrapperOption?: {
	wrapperStyle: string;
	postInputStyle: string;
	buttonStyle: string;
	titleStyle: string;
	inputStyle: string;
	detailAddressInputStyle: string;
  };
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onSearchClick?: () => void;
}

interface StyleSet {
	wrapperStyle: string;
	postInputStyle: string;
	buttonStyle: string;
	titleStyle: string;
	inputStyle: string;
	detailAddressInputStyle: string;
}

export const AddressForm = (props: Props) => {

	const {
		post,
		address,
		detailAddress,
		editable = true,
		handleFoucsId = "",
		titleless = false,
		wrapperOption = {
			wrapperStyle: "w-[725px] mr-[10px]",
			postInputStyle: 'w-[50px] min-w-[50px]' + ' ' + inputAddressMRClass,
			buttonStyle: 'px-[12px]' + ' ' + inputAddressMRClass,
			titleStyle: 'w-[100px] min-w-[100px] text-left',
			inputStyle: 'w-[308px] min-w-[308px]',
			detailAddressInputStyle: 'w-[100px] min-w-[100px]',
		},
		onChange,
		onSearchClick 
	} = props;

	const buttonRef = useRef<HTMLButtonElement>(null);
	const [isPostHovered, setIsPostHovered] = useState(false); // post 필드 호버 상태
	const [isAddressHovered, setIsAddressHovered] = useState(false); // address 필드 호버 상태

	const inputRef = useRef<HTMLInputElement>(null);

	//평소 화면 인풋 스타일, 커스텀 가능
	const normalStyleJson = {
		wrapperStyle: wrapperOption.wrapperStyle,
		postInputStyle: wrapperOption.postInputStyle,
		buttonStyle: wrapperOption.buttonStyle,
		titleStyle: wrapperOption.titleStyle,
		inputStyle: wrapperOption.inputStyle + ' ' + inputAddressMRClass,
		detailAddressInputStyle: wrapperOption.detailAddressInputStyle,
	};

	// useEffect(() => {
	// 	if (inputRef.current) {
	// 		inputRef.current.focus();
	// 	}
	// }, [address]);

	const buttonRefClick = () => {
		if (buttonRef.current) {
			buttonRef.current.click();
		}
	}

	return (
		<div className={`flex flex-wrap ${normalStyleJson.wrapperStyle}`}>
			<p	className={`${normalStyleJson.titleStyle} form-title cursor-pointer ${titleAddressMRClass} ${titleAddressMBClass} ${titleless ? 'hidden' : ''}`} 
				onClick={
					() => { buttonRefClick(); }
				}
				tabIndex={editable ? 0 : -1}
				>
				주소
			</p>
			<p 
				className={`bg-gray-disable ${normalStyleJson.postInputStyle} text-center rounded-[4px] border-[1px] ${inputAddressMBClass}`}
				// onClick={buttonRefClick}
				onMouseEnter={() => setIsPostHovered(true)}
				onMouseLeave={() => setIsPostHovered(false)}
				>
				{post}
			</p>
			{editable &&
				<button className={`text-white rounded-[4px] bg-white border-[1px] border-gray-300 hover:bg-gray-200 font-semibold ${normalStyleJson.buttonStyle} ${inputAddressMBClass}`} 
						onClick={onSearchClick}
						ref={buttonRef}>
					🔎
				</button>
			}
			<input
				className={`${normalStyleJson.inputStyle} 
							bg-gray-disable px-[6px] rounded-[4px] border-[1px] cursor-pointer text-left
							${inputAddressMBClass}`}
				data-type="address_info"
				id={handleFoucsId}
				// onClick={buttonRefClick}
				onMouseEnter={() => setIsAddressHovered(true)}
				onMouseLeave={() => setIsAddressHovered(false)}
				value={address}
				onChange={() => {}}
				tabIndex={editable ? 0 : -1}
				/>
			<input	className={`${editable ? 'bg-white' : 'bg-gray-disable'} px-[6px] ${normalStyleJson.detailAddressInputStyle} ${inputAddressMBClass} rounded-[4px] border-[1px]`}
			 		name="detailAddress"
					ref={inputRef}
					placeholder="상세주소"
					value={detailAddress}
					onChange={onChange} 
					onKeyDown={handleKeyDown}
					tabIndex={editable ? 0 : -1}
					/>
		</div>
	)
}